<template lang="html">
<div>
    <div class="inner-page">
        <Header class="header" @goFrash="goFrash">
              <Search :intext="searchText" @goSeek="inpSeek" :noBorder="true" />
        </Header>
        <div class="seek-head">

              <SubItem ref="subItem1" :itemArrs="subArrs1" labelType="middle" subkey="seek-1" @itemSelect="subSelect">
                  <div class="seek-item" @click="subOpen('subItem1')">
                      <div>
                          <span>{{subArrs1[listType-1]}}</span>
                          <van-icon class="icon" class-prefix="iconfont" name="downOpen" />
                      </div>
                  </div>
              </SubItem>

              <SubItem ref="subItem2" :itemArrs="subArrs2" labelType="middle" subkey="seek-2" @itemSelect="subSelect">
                  <div class="seek-item" @click="subOpen('subItem2')">
                      <div>
                          <span>{{subArrs2[ralateType-1]}}</span>
                          <van-icon class="icon" class-prefix="iconfont" name="downOpen" />
                      </div>
                  </div>
              </SubItem>

              <div :class="['seek-item',{'act':isSelected}]" @click="sideOpen">
                  <span>筛选</span>
              </div>
        </div>

        <div class="scroll-list">
            <div class="scroll-inner" :style="'height:' + scrollH + 'px'">
                <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

                </van-pull-refresh> -->
                <p class="lookMore" v-if="$store.state.user.token==''">查看更多资源请登录</p>
                <AlbumList class="album-list" :listDat="songList" :listType="listType" :iconType="1" />
                <div class="tapMore">
                     <van-loading v-if="isLoading" class="load-icon" size="21" color="#af2d2d">加载中...</van-loading>
                     <div class="btn" v-else-if="inSeek.allPage>inSeek.no" @click="onRefresh">加载更多</div>
                </div>

                <Footer @goFrash="goFrash" />
            </div>
            <Loading :firstLoading="firstLoading" />
        </div>

        <SidePage ref="sidePage" :inDat="reSeekDat" @goSeek="goSeek" />


    </div>
</div>
</template>

<script>
import vEmits from "@/utils/vEmits";
import Search from "@/components/Search";
import AlbumList from "@/components/AlbumList";
import SidePage from "@/components/SidePage/SidePage";
import SubItem from "@/components/subItem";
import Loading from "@/components/loading";
import { mapState } from 'vuex';

import { seek } from "@/api/seek";

export default {
      components:{
          Search,
          AlbumList,
          SidePage,
          SubItem,
          Loading
      },
    computed:{
        ...mapState('player',{
            state:'state'
        }),
        // infos : function () {
        //      if(this.songDat.info){
        //           return JSON.parse(this.songDat.info);
        //      }
        // }
    },
      data(){
          return{
               // state:2,
               searchText:'',
               scrollH:'',
               sideState:false,     // 侧边栏分类

               listType:2,     // 列表类型
               ralateType:2,      // 排序
               subArrs1:['专辑','单曲'],
               subArrs2:['相关性','题名','出版最早','出版最晚'],

               inSeek:{
                   size:12,
                   no:1,
                   allPage:0
               },

               classPms:{},

               firstLoading:false,
               isLoading:false,
               songList:[],
               reSeekDat:'',

               isSelected:false
          }
      },
      methods:{
          sideOpen:function(){
              this.$refs.sidePage.sideOpen();
          },
          subOpen:function(string){
              this.$refs[string].show();
          },
          subSelect:function(e){
              if(this.firstLoading){
                  vEmits.$emit('show','操作太频繁，请稍后再试');
              }else{
                  if(e.key == 'seek-1'){
                      this.listType = e.inx + 1;
                  }else{
                      this.ralateType = e.inx + 1;
                  }
                  this.inSeek.no = 1;
                  this.seek();
              }

          },
          seek:function(){
              let vs = this;
              let params = {
                   whereList:[{
                       where:this.searchText,
                       type:1
                   }],
                   sort:this.ralateType,
                   modelType:this.listType,
                   size:this.inSeek.size,
                   no:this.inSeek.no
              }
              if(this.inSeek.no == 1){
                   this.firstLoading = true;
              }else{
                   this.isLoading = true;
              }
              seek(Object.assign(params,this.classPms)).then(res => {

                   vs.inSeek.allPage = res.totalPages;
                   if(this.inSeek.no == 1){
                        vs.songList = res.materialList;
                        this.firstLoading = false;
                   }else{
                        vs.songList = vs.songList.concat(res.materialList);
                        // this.$refs.toast.show('加载完成 !');
                   }

                   vs.reSeekDat = res.searchFilter;

                   this.isLoading = false;

              }).catch(errs => {
                  window.console.log(errs)
              })
          },
          onRefresh:function(){
              this.inSeek.no++;
              this.seek();
          },
          goSeek:function(e){
              let pmsMap = {};
              let pmsC = 0;
              for(let i = 0;i < e.length;i++){
                  for(let k = 0;k < e[i].length;k++){
                      let tempKey = e[i][k].postKey;
                      if(!pmsMap[tempKey]){
                          pmsMap[tempKey] = [];
                      }
                      if(e[i][k].id == '1990+'){
                          pmsMap[tempKey].push('1990~0');
                      }else{
                          pmsMap[tempKey].push(e[i][k].id);
                      }

                      pmsC++;
                  }
              }
              if(pmsC > 0){
                  this.isSelected = true;
              }else{
                  this.isSelected = false;
              }

              if(this.firstLoading){
                  vEmits.$emit('show','操作太频繁，请稍后再试');
              }else{
                  this.classPms = pmsMap;
                  this.inSeek.no = 1;
                  this.seek();
              }
          },

          inpSeek:function(text){
              if(this.firstLoading){
                  vEmits.$emit('show','操作太频繁，请稍后再试');
              }else{
                  this.$refs.sidePage.cleanSelect();
                  this.listType = 2;
                  this.ralateType = 2;
                  this.inSeek.no = 1;
                  this.searchText = text;
                  this.seek();
              }
          },

          goFrash:function(){
              this.$emit('pageFrash');
          }
      },
      created:function(){
          let queryDat = this.$route.query;
          this.searchText = queryDat.stext;

          this.scrollH = document.documentElement.clientHeight - 167;

      },

      mounted:function(){
          let querys = this.$route.query;
          if(querys.classId){
              this.goSeek([[{
                  id:querys.classId,
                  postKey:"classifyList",
                  text:querys.classText
              }]]);
              this.isSelected = true;
          }else{
              this.seek();
          }

      }
}
</script>

<style lang="css" scoped>

    .lookMore{
        font-size: 12px;
        text-align: center;
    }
.header{
    padding-top: 12px;
    padding-bottom: 6px;
    border-bottom: 1px solid #f8f8f8;
    height: 52px;
}

.seek-head{
    height: 45px;
    display: flex;
    padding: 0 10px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #efefef;
    background: white;
    position: relative;
    z-index: 2;
}

.seek-head .seek-item{
    height: 60px;
    width: 90px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.seek-head .seek-item span{
    color: #666666;
    font-size: 15px;
}

.seek-head .seek-item .icon{
    color: #999999;
    font-size: 9px;
    margin-left: 3px;
    margin-top: 1px;
}

.seek-head .seek-item span,
.seek-head .seek-item .icon{
   display: inline-block;
   vertical-align: middle;
}

.seek-head .seek-item.act span{
   color: #af2d2d;
}

/* 列表 */

.album-list{
    background: white;
    min-height: 300px;
}

.scroll-list{
    position: relative;
}

.scroll-inner{
    position: relative;
    overflow-y: scroll;
}

/* 加载更多 */

.tapMore{
     height: 45px;
     background: white;
     display: flex;
     align-items: center;
     justify-content: space-around;
}

.tapMore .btn{
     display: inline-block;
     padding: 6px 18px;
     color: #666666;
     font-size: 15px;
     margin: 0 auto;
     color: #999999;
}

</style>
